import { useHistory } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { IconButton, LinearProgress, ListItem, Stack, Typography } from "@mui/material";

import { AmountInCustomerCurrency } from "../AmountInCustomerCurrency";
import { type ParsedBudget } from "../types";
import { getTimeText, getUtilizationProgressBarColor } from "../utils";

export const BudgetRow = ({ budget, hideDivider }: { budget: ParsedBudget; hideDivider: boolean }) => {
  const currentUsage = budget.budgetAmount === 0 ? 0 : (budget.actualAmountToDate / budget.budgetAmount) * 100;

  const history = useHistory();

  const handleClick = () => {
    history.push(`./monitor/budgets/${budget.id}/view`);
  };

  return (
    <ListItem
      divider={!hideDivider}
      sx={{
        display: "flex",
        flexDirection: "row",
        cursor: "pointer",
      }}
      onClick={handleClick}
    >
      <Stack width="100%" pr={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="body2" noWrap>
            {budget.name}
          </Typography>
          <Typography variant="subtitle2" color="text.primary" sx={{ textAlign: "right" }}>
            {currentUsage.toFixed(0)}%
          </Typography>
        </Stack>
        <Stack sx={{ width: "100%" }}>
          <LinearProgress
            variant="determinate"
            value={Math.min(100, currentUsage)}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: "general.divider",
              "& .MuiLinearProgress-bar": {
                backgroundColor: getUtilizationProgressBarColor(currentUsage),
              },
            }}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="caption" color="text.secondary">
            <AmountInCustomerCurrency amount={budget.actualAmountToDate} dontConvert /> /{" "}
            <AmountInCustomerCurrency amount={budget.budgetAmount} dontConvert />
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ textAlign: "right" }}>
            {getTimeText(currentUsage, budget.timeWhenTotalAmountExceeded)}
          </Typography>
        </Stack>
      </Stack>
      <IconButton size="small" data-cy="insights-item-next">
        <ChevronRightIcon fontSize="inherit" />
      </IconButton>
    </ListItem>
  );
};
